// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"TenantDashboard_Wrapper__3xpTv","PrintWrapper":"TenantDashboard_PrintWrapper__ANB7s"};